import {
  Table,
  TableHeader,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "src/components/ui/table";
import { useEffect, useState } from "react";
import { userStore } from "src/store/userStore";
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationPrevious,
  PaginationLink,
  PaginationNext,
} from "src/components/ui/pagination";
import { Input } from "src/components/ui/input";
import { debounce } from "src/lib/helper";
import Div from "src/components/typography/div";
import H4 from "src/components/typography/h4";
import { LoadingStates } from "src/store/projectStore";
import Spinner from "src/components/ui/spinner";

interface User {
  userId: string;
  emailId: string;
  mobileNumber: string;
  firstName: string;
  lastName: string;
  userType: string;
  userCategory: string;
  roles: string;
  approvedProjectCount: number;
  flexiField1: string | null;
  flexiField2: string | null;
  flexiField3: string | null;
  userInvited: boolean;
}

function formatUserName(data: User) {
  let name = "";
  if (data.firstName) name = data.firstName;
  if (data.lastName) name = name + " " + data.lastName;
  if (!Boolean(name)) return "N/A";
  return name;
}

export function Users(props: any) {
  const { page, size, userList, updatePage, getAllUsers } = userStore();

  const [emailId, setEmailId] = useState("");

  useEffect(() => {
    getAllUsers({ emailId });
  }, [page, size, emailId]);

  function handleEmailSearch(e: any) {
    setEmailId(e.target.value);
  }
  return (
    <Div className="pt-0">
      <H4>Users</H4>
      <div className="mb-6 "></div>
      <Table>
        <TableHeader className="bg-black">
          <TableHead className="pl-4  rounded-s-md text-white">Lvl</TableHead>
          <TableHead className="pl-4  text-white">Name</TableHead>

          <TableHead className="text-white">
            <Input
              onChange={debounce(handleEmailSearch, 300)}
              placeholder={"Email"}
              className="  placeholder:text-white placeholder:font-extrabold font-extrabold "
            />
          </TableHead>
          <TableHead className={"text-white"}>Approved Projects</TableHead>
          <TableHead className={"text-white rounded-e-md pr-4"}>
            Number
          </TableHead>
          {/* <TableHead className={"text-white rounded-e-md pr-4"}>
            Role
          </TableHead> */}
        </TableHeader>
        <TableBody>
          {Array.isArray(userList) &&
            userList.map((user: User) => (
              <TableRow key={user.userId}>
                <TableCell>
                  <UserAvatar
                    approvedProjectCount={user.approvedProjectCount}
                  />
                </TableCell>
                <TableCell>{formatUserName(user)}</TableCell>
                <TableCell>{user.emailId}</TableCell>
                <TableCell className="text-center">
                  {user.approvedProjectCount}
                </TableCell>
                <TableCell>{user?.mobileNumber || "N/A"}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      {userList === LoadingStates.LOADING && (
        <div className="w-full m-auto">
          <Spinner />
        </div>
      )}
      {Array.isArray(userList) && Boolean(!userList?.length) && (
        <div className=" text-center p-6">Welp, No users found!!</div>
      )}
      {Array.isArray(userList) && (
        <Pagination>
          <PaginationContent>
            <PaginationItem
              onClick={() => {
                updatePage(page - 1);
              }}
              hidden={page == 0}
            >
              <PaginationPrevious href="#" />
            </PaginationItem>
            <PaginationItem
              hidden={0 < userList?.length && 10 > userList?.length}
              onClick={() => {
                updatePage(page + 1);
              }}
            >
              <PaginationNext href="#" />
            </PaginationItem>
          </PaginationContent>
        </Pagination>
      )}
    </Div>
  );
}

export function UserAvatar({ approvedProjectCount }: any) {
  let lvl = 0;

  lvl = approvedProjectCount === 1 ? 1 : approvedProjectCount > 1 ? 2 : 0;

  return (
    <div className="h-8 w-8 border-2 flex justify-center items-center rounded-full relative">
      {"L" + lvl}
    </div>
  );
}
